import React from 'react';
import { CTABanner } from '../CTABanner';

export default function CTABannerBlock({
  title,
  description,
  link,
  terms,
  bgImage,
  buttonColor,
  containerClassName,
}) {
  return (
    <CTABanner
      containerClassName={containerClassName}
      title={title || ''}
      description={description || ''}
      button_url={link?.link_url || undefined}
      button_text={link?.link_text || undefined}
      terms={terms || ''}
      bgImage={bgImage || undefined}
      buttonColor={buttonColor || undefined}
      wide
    />
  );
}
